// Copyright © 2025 The Things Industries B.V.

import React from 'react'
import classNames from 'classnames'

import { getContrastingTextColor } from '@console/components/pill/utils.tti'

import PropTypes from '@ttn-lw/lib/prop-types'

const Pill = ({ color, text, className }) => {
  const { textColor, withBorder } = getContrastingTextColor(color)
  return (
    <div
      className={classNames(
        'p-vert-cs-xs p-sides-cs-s mt-0 fw-bold d-block w-content br-xl fs-xs lh-1 h-content no-wrap',
        className,
      )}
      style={{
        backgroundColor: color,
        color: textColor,
        border: withBorder ? `1px solid var(--c-border-neutral-normal)` : 'unset',
      }}
    >
      {text}
    </div>
  )
}

Pill.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
}

Pill.defaultProps = {
  className: undefined,
}

export default Pill
